import Highlights from "./Highlights";
import compose from "recompose/compose";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";
import { connect } from "react-redux";
import { setCloseOverlay, setOpenOverlay } from "../../../store/actions/app";

const enhance = compose(
  connect(null, (dispatch) => ({
    openOverlay: (scrollPos) => dispatch(setOpenOverlay(scrollPos)),
    closeOverlay: () => dispatch(setCloseOverlay()),
  })),
  withState("isOpen", "setIsOpen", (props) => props.isOpen),
  withHandlers({
    handleOpenModal: (props) => (e) => {
      e.preventDefault();
      props.openOverlay(window.scrollY);
      props.setIsOpen(true);
    },
    handleCloseModal: (props) => (e) => {
      e.preventDefault();
      props.closeOverlay();
      props.setIsOpen(false);
    },
  })
);

export default enhance(Highlights);
